import axios from './axios';

export interface DgiWS1Response {
  result: boolean;
  data: {
    exists: boolean;
    rut: string;
    businessName: string;
    fantasyName?: string;
    entityType: string;
    entityTypeDescription: string;
    activityStatus: string;
    activityStartDate: string;
    address: {
      street: string;
      number: string;
      apartment?: string;
      city: string;
      state: string;
      postalCode: string;
      contacts: Array<{
        type: string;
        description: string;
        value: string;
      }>;
    };
    activities: Array<{
      code: string;
      name: string;
      startDate: string;
    }>;
    giroMapping?: {
      originalGiro: string;
      mappedCategory: string | null;
      categoryId: string | null;
    };
  };
  errorCode: number;
  message?: string;
  needUpdate: boolean;
  showMessage?: string;
}

export interface DgiWS2Response {
  result: boolean;
  data: {
    rut: string;
    companyInfo: {
      number: string;
      businessName: string;
      fiscalAddress: string;
      contributorType: string;
      status: string;
    };
  };
  errorCode: number;
  message?: string;
  needUpdate: boolean;
  showMessage?: string;
}

export const getDgiWS1Info = async (rut: string): Promise<DgiWS1Response> => {
  try {
    const response = await axios.get(`/dgi/ws1/${rut}`);
    return response.data;
  } catch (error: any) {
    return {
      result: false,
      data: {
        exists: false,
        rut,
        businessName: '',
        fantasyName: '',
        entityType: '',
        entityTypeDescription: '',
        activityStatus: '',
        activityStartDate: '',
        address: {
          street: '',
          number: '',
          apartment: '',
          city: '',
          state: '',
          postalCode: '',
          contacts: [],
        },
        activities: [],
        giroMapping: {
          originalGiro: '',
          mappedCategory: null,
          categoryId: null,
        },
      },
      errorCode: 1,
      message: error.response?.data?.message || 'Error al consultar información DGI WS1',
      needUpdate: false,
      showMessage: undefined,
    };
  }
};

export const getDgiWS2Info = async (rut: string): Promise<DgiWS2Response> => {
  try {
    const response = await axios.get(`/dgi/ws2/${rut}`);
    return response.data;
  } catch (error: any) {
    return {
      result: false,
      data: {
        rut,
        companyInfo: {
          number: '',
          businessName: '',
          fiscalAddress: '',
          contributorType: '',
          status: '',
        },
      },
      errorCode: 1,
      message: error.response?.data?.message || 'Error al consultar información DGI WS2',
      needUpdate: false,
      showMessage: undefined,
    };
  }
};

export const validateRutFormat = (rut: string): boolean => {
  const rutPattern = /^\d{12}$/;
  return rutPattern.test(rut);
};

export const sanitizeRut = (rut: string): string => {
  const cleanRut = rut.replace(/\D/g, '');
  return cleanRut.padStart(12, '0');
};
